import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import BPCurrentForecastTracker from "./BPCurrentForecastTracker";
import BPPastForecastTracker from "./BPPastForecastTracker";
import { setActiveDataElement } from "../../../redux/userSlice";


const BPDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Business Plan"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/business-plan-dashboard"},
                { title: "Dashboard" },
              ]}
              title="Bottler Business Plan Upload Dashboard"
            />
            <div className="container">
                {/* top table */}
             <BPCurrentForecastTracker />
             {/* bottom table */}
             <BPPastForecastTracker />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default BPDashboard;
